import * as React from "react";
import type { SVGProps } from "react";
const SvgHelpOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={15}
    height={16}
    fill="none"
    {...props}
  >
    <path
      fill="#74758C"
      d="M6.875 11.75h1.25V10.5h-1.25zm.625-10a6.25 6.25 0 1 0 0 12.5 6.25 6.25 0 0 0 0-12.5M7.5 13c-2.756 0-5-2.244-5-5s2.244-5 5-5 5 2.244 5 5-2.244 5-5 5m0-8.75A2.5 2.5 0 0 0 5 6.75h1.25a1.25 1.25 0 0 1 2.5 0c0 1.25-1.875 1.094-1.875 3.125h1.25C8.125 8.469 10 8.313 10 6.75a2.5 2.5 0 0 0-2.5-2.5"
    />
  </svg>
);
export default SvgHelpOutline;
